import { jsxs as f, jsx as l } from "react/jsx-runtime";
import { c as a } from "../../index-Cu0xwYjD.js";
import { forwardRef as h, useState as B, useId as C, useEffect as x } from "react";
import { GlobalCSSClass as I } from "../../utils/enums.js";
import { propagateTestid as u } from "../../utils/helpers.js";
import "../CheckboxMark/CheckboxMark.types.js";
import { IressCheckboxMark as N } from "../CheckboxMark/CheckboxMark.js";
import { ButtonCssClass as T } from "../Button/Button.types.js";
import { ToggleLayout as w } from "./Toggle.types.js";
const L = "ids-toggle--toggle-base-v501", M = "ids-toggle--checkbox-mark-v501", S = "ids-toggle--toggle-button-v501", j = "ids-toggle--button-checked-v501", R = "ids-toggle--toggle-button-container-v501", $ = "ids-toggle--label-v501", E = "ids-toggle--layout__inline-v501", G = "ids-toggle--layout__stack-v501", t = {
  toggleBase: L,
  checkboxMark: M,
  toggleButton: S,
  buttonChecked: j,
  toggleButtonContainer: R,
  label: $,
  layout__inline: E,
  "layout__inline-reverse": "ids-toggle--layout__inline-reverse-v501",
  "layout__inline-between": "ids-toggle--layout__inline-between-v501",
  layout__stack: G
}, O = ({
  hiddenLabel: o,
  children: i,
  "data-testid": n,
  ...g
}) => /* @__PURE__ */ l(
  "span",
  {
    ...g,
    className: a(t.label, {
      [I.SROnly]: o
    }),
    "data-testid": u(n, "label"),
    children: i
  }
), b = h(
  ({
    checked: o = !1,
    hiddenLabel: i,
    children: n,
    layout: g = "inline",
    className: m,
    onChange: s,
    "data-testid": c,
    ..._
  }, k) => {
    const [e, r] = B(o), d = `toggleLabel--${C()}`, y = {
      hiddenLabel: i,
      id: d,
      "data-testid": c
    }, v = (p) => {
      r(!e), s == null || s(!e, p);
    };
    return x(() => {
      r(o);
    }, [o, s]), /* @__PURE__ */ f(
      "div",
      {
        "data-testid": c,
        ..._,
        className: a(
          m,
          t.toggleBase,
          t[`layout__${g}`]
        ),
        ref: k,
        children: [
          /* @__PURE__ */ l(O, { ...y, children: n }),
          /* @__PURE__ */ l("div", { className: t.toggleButtonContainer, children: /* @__PURE__ */ l(
            "button",
            {
              className: a(T.Base, t.toggleButton, {
                [t.buttonChecked]: e
              }),
              role: "switch",
              type: "button",
              "aria-checked": e,
              onClick: v,
              "aria-labelledby": d,
              "data-testid": u(c, "button__button"),
              children: /* @__PURE__ */ l(
                N,
                {
                  className: a(t.checkboxMark, {
                    "visibility-hidden": !e
                  }),
                  checked: e
                }
              )
            }
          ) })
        ]
      }
    );
  }
);
b.displayName = "IressToggle";
b.Layout = w;
export {
  b as IressToggle
};
